import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
  InputGroup,
  FormCheck,
  OverlayTrigger,
  Popover,
  Button,
} from "react-bootstrap";
import i18n from "i18next";
import FileInput from "../../../common/file-input/FileInput";
import { ADD_BOX } from "../../../../../common/actions";
import { isContainedView, isSlide } from "../../../../../common/utils";
import { randomPositionGenerator } from "../../../clipboard/clipboard.utils";
import {
  ID_PREFIX_BOX,
  ID_PREFIX_PAGE,
  ID_PREFIX_SORTABLE_CONTAINER,
  PAGE_TYPES,
} from "../../../../../common/constants";
import IdealStudio from "../../../../../core/editor/main";
// styles
import { createBox } from "../../../../../common/common_tools";
let spinner = require("../../../../../dist/images/spinner.svg");

// PDF.js v3.x with React 19 compatibility
let pdflib = null;
let pdfSupported = true;

try {
  pdflib = require("pdfjs-dist");

  // Configure worker for PDF.js v3.x
  if (pdflib.GlobalWorkerOptions) {
    pdflib.GlobalWorkerOptions.workerSrc =
      "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
  }

  console.log("PDF.js loaded successfully");
} catch (error) {
  console.error("PDF.js could not be loaded:", error);
  pdfSupported = false;
}

/**
 * Generic import file modal
 */
export default class PDFHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FileURL: "",
      FileLoaded: false,
      FileName: "",
      FilePages: 0,
      FileType: "",
      ImportAs: "Custom",
      PagesFrom: 1,
      PagesTo: 1,
    };
    this.AddPlugins = this.AddPlugins.bind(this);
    this.AddAsNavItem = this.AddAsNavItem.bind(this);
    this.fileLoad = this.fileLoad.bind(this);
    this.importFile = this.importFile.bind(this);
    this.PreviewFile = this.PreviewFile.bind(this);
    this.start = this.start.bind(this);
  }
  componentWillUnmount() {
    for (let i = 1; i <= this.state.FilePages; i++) {
      let canvas = document.getElementById("can" + i);
      if (canvas) {
        document.body.removeChild(canvas);
      }
    }
  }
  componentDidMount() {
    this.start();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.url !== this.props.url) {
      for (let i = 1; i <= prevState.FilePages; i++) {
        let canvas = document.getElementById("can" + i);
        document.body.removeChild(canvas);
      }
      this.start();
    }
  }

  start() {
    if (this.props.url && pdfSupported && pdflib) {
      try {
        let loadingTask = pdflib.getDocument({ url: this.props.url, isEvalSupported: false });
        if (!loadingTask) {
          console.error("Failed to create PDF loading task");
          return;
        }

        // Handle both v2 (promise property) and v5+ (direct promise) API
        let documentPromise = loadingTask.promise || loadingTask;
        documentPromise
          .then((pdfDocument) => {
            if (!pdfDocument) {
              console.error("PDF document is null or undefined");
              return;
            }

            let numPages = pdfDocument.numPages;
            this.setState({
              FileURL: this.props.url,
              FileLoaded: true,
              FileName: this.props.url,
              FilePages: numPages,
              PagesTo: numPages,
              FileType: "(.pdf)",
              ImportAs: "Custom",
            });
            // Request pages
            let page;
            for (let i = 1; i <= numPages; i++) {
              page = pdfDocument
                .getPage(i)
                .then((pdfPage) => {
                  if (!pdfPage) {
                    console.error(`PDF page ${i} is null or undefined`);
                    return;
                  }

                  // Display page on the existing canvas with 100% scale.
                  let viewport = pdfPage.getViewport({ scale: 1.0 });
                  let canvas = document.createElement("canvas");
                  document.body.appendChild(canvas);
                  canvas.id = "can" + i;
                  canvas.style.visibility = "hidden";
                  canvas.width = viewport.width;
                  canvas.height = viewport.height;
                  let ctx = canvas.getContext("2d");
                  let renderTask = pdfPage.render({
                    canvasContext: ctx,
                    viewport: viewport,
                  });
                  if (i === 1) {
                    renderTask.promise
                      .then(() => {
                        this.PreviewFile(i);
                      })
                      .catch((error) => {
                        console.error("Error rendering first page:", error);
                      });
                  }
                  return renderTask.promise;
                })
                .catch((error) => {
                  console.error(`Error loading page ${i}:`, error);
                });
            }
            return page;
          })
          .catch((reason) => {
            console.error("Error loading PDF document:", reason);
          });
      } catch (error) {
        console.error("Error in PDF start method:", error);
      }
    }
  }
  /**
   * Renders React component
   * @returns {code}
   */
  render() {
    if (!pdfSupported) {
      return (
        <div className="pdfFileDialog">
          <div className="fileLoaded" style={{ display: "block" }}>
            <h2>PDF functionality is currently unavailable</h2>
            <p>There was an error loading the PDF library. Please try refreshing the page.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="pdfFileDialog">
        <form action="javascript:void(0);" onSubmit={(e) => e.preventDefault()}>
          <div className="fileLoaded" style={{ display: "block" }}>
            <h2>{i18n.t("Preview")}</h2>
          </div>
          <Row style={{ display: "block" }}>
            <Col xs={12} md={6} lg={6}>
              <img id="FilePreview" src={spinner} style={{ width: "auto", padding: "25%" }} />
            </Col>
            <Col xs={12} md={6} lg={6}>
              <FormGroup>
                <FormLabel>{i18n.t("importFile.pages.title")}</FormLabel>
                <FormCheck
                  name="radioPages"
                  inline
                  onChange={(e) => {
                    this.setState({ PagesFrom: 1, PagesTo: this.state.FilePages });
                  }}
                  defaultChecked
                >
                  {i18n.t("importFile.pages.whole_file")} ({this.state.FilePages})
                </FormCheck>
                <FormCheck name="radioPages" inline>
                  <FormGroup>
                    <InputGroup className="inputGroup">
                      <InputGroup.Text>{i18n.t("importFile.pages.from")}</InputGroup.Text>
                      <FormControl
                        type="number"
                        style={{ minWidth: "55px" }}
                        value={this.state.PagesFrom}
                        min={1}
                        max={this.state.FilePages}
                        onChange={(e) => {
                          this.setState({ PagesFrom: e.target.value });
                        }}
                      />
                    </InputGroup>
                    <InputGroup className="inputGroup">
                      <InputGroup.Text>{i18n.t("importFile.pages.to")}</InputGroup.Text>
                      <FormControl
                        type="number"
                        style={{ minWidth: "55px" }}
                        value={this.state.PagesTo}
                        min={1}
                        max={this.state.FilePages}
                        onChange={(e) => {
                          this.setState({ PagesTo: e.target.value });
                        }}
                      />
                    </InputGroup>
                  </FormGroup>
                </FormCheck>
              </FormGroup>
              <FormGroup>
                <FormLabel>{i18n.t("importFile.importAs.title")}</FormLabel>
                <FormCheck
                  name="radioImport"
                  inline
                  onChange={(e) => {
                    this.setState({ ImportAs: "SliBackground" });
                  }}
                >
                  {i18n.t("importFile.importAs.slideBackground")}
                </FormCheck>
                <FormCheck
                  name="radioImport"
                  inline
                  onChange={(e) => {
                    this.setState({ ImportAs: "Image" });
                  }}
                >
                  {i18n.t("importFile.importAs.images")}
                </FormCheck>
                <FormCheck
                  name="radioImport"
                  inline
                  defaultChecked
                  onChange={(e) => {
                    this.setState({ ImportAs: "Custom" });
                  }}
                >
                  {i18n.t("importFile.importAs.customSize")}
                </FormCheck>
                <FormCheck
                  name="radioImport"
                  inline
                  onChange={(e) => {
                    this.setState({ ImportAs: "PDFViewer" });
                  }}
                >
                  {i18n.t("importFile.importAs.PDFViewer")}
                </FormCheck>
              </FormGroup>
              <div className="import_file_buttons">
                <Button
                  variant="secondary"
                  className="import_file_buttons"
                  id="import_file_button"
                  onClick={(e) => {
                    this.closeModal();
                    e.preventDefault();
                  }}
                >
                  {i18n.t("importFile.footer.cancel")}
                </Button>
                <Button
                  variant="primary"
                  className="import_file_buttons"
                  id="cancel_button"
                  onClick={(e) => {
                    this.importFile(e);
                    e.preventDefault();
                  }}
                >
                  {i18n.t("importFile.footer.ok")}
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </div>
    );
  }

  importFile() {
    switch (this.state.FileType) {
      case "(.pdf)":
        switch (this.state.ImportAs) {
          case "Image":
            this.AddPlugins();
            break;
          case "SliBackground":
            this.AddAsNavItem();
            break;
          case "Custom":
            this.AddAsNavItem(true);
            break;
          case "PDFViewer":
            this.AddAsPDFViewer();
            break;
        }
    }

    // delete canvas preview util
    for (let i = 1; i <= this.state.FilePages; i++) {
      let canvas = document.getElementById("can" + i);
      document.body.removeChild(canvas);
    }
    // reset state
    this.setState({
      FileURL: "",
      FileLoaded: false,
      FileName: "",
      FilePages: 0,
      FileType: "",
      ImportAs: "",
      PagesFrom: 1,
      PagesTo: 1,
    });

    this.closeModal(true);
  }

  AddAsPDFViewer() {
    // insert image plugins
    let cv =
      this.props.containedViewSelected !== 0 && isContainedView(this.props.containedViewSelected);
    let cvSli = cv && isSlide(this.props.containedViews[this.props.containedViewSelected].type);
    let cvDoc = cv && !isSlide(this.props.containedViews[this.props.containedViewSelected].type);
    let inASlide =
      (this.props.navItemSelected !== 0 &&
        isSlide(this.props.navItems[this.props.navItemSelected].type)) ||
      cvSli;
    let page = cv ? this.props.containedViewSelected : this.props.navItemSelected;
    let initialParams;
    // If slide
    if (inASlide) {
      let position = {
        x: randomPositionGenerator(20, 40),
        y: randomPositionGenerator(20, 40),
        type: "absolute",
        page,
      };
      initialParams = {
        parent: cvSli ? this.props.containedViewSelected : this.props.navItemSelected,
        container: 0,
        position: position,
        url: this.props.url,
        page,
      };
    } else {
      initialParams = {
        parent: cvDoc
          ? this.props.containedViews[this.props.containedViewSelected].boxes[0]
          : this.props.navItems[this.props.navItemSelected].boxes[0],
        container: ID_PREFIX_SORTABLE_CONTAINER + Date.now(),
        url: this.props.url,
        page,
      };
    }
    initialParams.id = ID_PREFIX_BOX + Date.now();
    createBox(initialParams, "EnrichedPDF", inASlide, this.props.onBoxAdded, this.props.boxes);
  }

  AddAsNavItem(hasCustomSize) {
    let navs = [];
    for (let i = this.state.PagesFrom; i <= this.state.PagesTo; i++) {
      let canvas = document.getElementById("can" + i);
      let dataURL = canvas.toDataURL("image/jpeg", 1.0);
      let newId = ID_PREFIX_PAGE + Date.now() + "_" + i;
      let customSize = hasCustomSize ? { width: canvas.width, height: canvas.height } : 0;
      let nav = {
        id: newId,
        name: hasCustomSize ? i18n.t("page") + i + " PDF" : i18n.t("slide"),
        parent: 0,
        hideTitles: true,
        type: PAGE_TYPES.SLIDE,
        position: this.props.navItemsIds.length + navs.length,
        background: { background: dataURL, backgroundAttr: "centered" },
        customSize,
      };
      navs.push(nav);
    }
    this.props.onNavItemsAdded(navs, 0);
    if (navs.length > 0) {
      this.props.onIndexSelected(navs[navs.length - 1].id);
      this.props.onNavItemSelected(navs[navs.length - 1].id);
    }
  }

  // function for preview pages
  PreviewFile(page) {
    let preview = document.getElementById("FilePreview");
    let firstCanvas = document.getElementById("can" + page);

    preview.src = firstCanvas.toDataURL();
    if (firstCanvas.width > firstCanvas.height) {
      preview.style.width = "100%";
      preview.style.height = "auto";
    } else {
      preview.style.width = "auto";
      preview.style.height = "430px";
    }
    preview.style.border = "1px solid";
    preview.style.padding = "0px";
  }

  AddPlugins() {
    // insert image plugins
    let cv =
      this.props.containedViewSelected !== 0 && isContainedView(this.props.containedViewSelected);
    let cvSli = cv && isSlide(this.props.containedViews[this.props.containedViewSelected].type);
    let cvDoc = cv && !isSlide(this.props.containedViews[this.props.containedViewSelected].type);
    let inASlide = (!cv && isSlide(this.props.navItems[this.props.navItemSelected].type)) || cvSli;
    let page = cv ? this.props.containedViewSelected : this.props.navItemSelected;
    for (let i = this.state.PagesFrom; i <= this.state.PagesTo; i++) {
      let canvas = document.getElementById("can" + i);
      let dataURL = canvas.toDataURL("image/jpeg", 1.0);
      let initialParams;
      // If slide
      if (inASlide) {
        let position = {
          x: randomPositionGenerator(20, 40),
          y: randomPositionGenerator(20, 40),
          type: "absolute",
          page,
        };
        initialParams = {
          parent: cvSli ? this.props.containedViewSelected : this.props.navItemSelected,
          container: 0,
          position: position,
          url: dataURL,
          page,
        };
      } else {
        initialParams = {
          parent: cvDoc
            ? this.props.containedViews[this.props.containedViewSelected].boxes[0]
            : this.props.navItems[this.props.navItemSelected].boxes[0],
          container: ID_PREFIX_SORTABLE_CONTAINER + Date.now() + "_" + i,
          url: dataURL,
          page,
        };
      }
      initialParams.id = ID_PREFIX_BOX + Date.now() + "_" + i;
      createBox(initialParams, "HotspotImages", inASlide, this.props.onBoxAdded, this.props.boxes);
    }
  }

  fileLoad(event) {
    let file = event.target.files[0];
    if (!file) return;

    if (!pdfSupported || !pdflib) {
      console.error("PDF functionality is not available");
      return;
    }

    let pdfURL = URL.createObjectURL(file);

    if (file.type === "application/pdf") {
      try {
        let loadingTask = pdflib.getDocument({ url: pdfURL, isEvalSupported: false });
        if (!loadingTask) {
          console.error("Failed to create PDF loading task");
          return;
        }

        // Handle both v2 (promise property) and v5+ (direct promise) API
        let documentPromise = loadingTask.promise || loadingTask;
        documentPromise
          .then((pdfDocument) => {
            if (!pdfDocument) {
              console.error("PDF document is null or undefined");
              return;
            }

            let numPages = pdfDocument.numPages;
            this.setState({
              FileURL: pdfURL,
              FileLoaded: true,
              FileName: file.name,
              FilePages: numPages,
              FileType: "(.pdf)",
              ImportAs: "Custom",
            });
            // Request pages
            let page;
            for (let i = 1; i <= numPages; i++) {
              page = pdfDocument
                .getPage(i)
                .then((pdfPage) => {
                  if (!pdfPage) {
                    console.error(`PDF page ${i} is null or undefined`);
                    return;
                  }

                  // Display page on the existing canvas with 100% scale.
                  let viewport = pdfPage.getViewport({ scale: 1.0 });
                  let canvas = document.createElement("canvas");
                  document.body.appendChild(canvas);
                  canvas.id = "can" + i;
                  canvas.style.visibility = "hidden";
                  canvas.width = viewport.width;
                  canvas.height = viewport.height;
                  let ctx = canvas.getContext("2d");
                  let renderTask = pdfPage.render({
                    canvasContext: ctx,
                    viewport: viewport,
                  });
                  if (i === 1) {
                    renderTask.promise
                      .then(() => {
                        this.PreviewFile(i);
                      })
                      .catch((error) => {
                        console.error("Error rendering first page:", error);
                      });
                  }
                  return renderTask.promise;
                })
                .catch((error) => {
                  console.error(`Error loading page ${i}:`, error);
                });
            }
            return page;
          })
          .catch((reason) => {
            console.error("Error loading PDF document:", reason);
          });
      } catch (error) {
        console.error("Error in fileLoad method:", error);
      }
    }
  }

  /**
   * Close modal
   */
  closeModal(bool) {
    // delete canvas preview util
    for (let i = 1; i <= this.state.FilePages; i++) {
      let canvas = document.getElementById("can" + i);
      if (canvas) {
        document.body.removeChild(canvas);
      }
    }
    this.setState({
      FileLoaded: false,
      FileName: "",
      FilePages: 0,
      FileType: "",
      ImportAs: "",
      PagesFrom: 1,
      PagesTo: 1,
    });

    this.props.close(bool);
  }
}

PDFHandler.propTypes = {
  /**
   * Closes import file modal
   */
  close: PropTypes.func.isRequired,
  /**
   * Add several views
   */
  onNavItemsAdded: PropTypes.func.isRequired,
  /**
   * Select view/contained view in the index context
   */
  onIndexSelected: PropTypes.func.isRequired,
  /**
   * Select view
   */
  onNavItemSelected: PropTypes.func.isRequired,
  /**
   * Objects Array that contains all created views (identified by its *id*)
   */
  navItemsIds: PropTypes.array.isRequired,
  /**
   * Object that contains all created views (identified by its *id*)
   */
  navItems: PropTypes.object.isRequired,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Selected contained view (by ID)
   */
  containedViewSelected: PropTypes.any,
  /**
   * Object containing all created boxes (by id)
   */
  boxes: PropTypes.object,
  /**
   * Callback for adding a box
   */
  onBoxAdded: PropTypes.func.isRequired,
  /**
   * PDF File URL
   */
  url: PropTypes.string,
};
